import React from "react";

// Captura erros de render em qualquer componente filho e mostra um fallback amigável
// (sem isso, um erro derruba a árvore inteira e a tela fica branca). Estilos inline = à prova de falha.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: false };
  }

  static getDerivedStateFromError() {
    return { erro: true };
  }

  componentDidCatch(error, info) {
    // Log local. Em produção, daria para enviar a um serviço de monitoramento.
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary capturou:", error, info);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "Segoe UI, Arial, sans-serif", background: "#f8fafc", color: "#1D3557", textAlign: "center" }}>
        <div>
          <div style={{ fontSize: 44 }}>😕</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, marginTop: 8 }}>Algo deu errado</h1>
          <p style={{ color: "#5b6b7f", marginTop: 6, maxWidth: 380 }}>
            Tivemos um problema ao carregar esta parte do site. Tente recarregar — seus dados estão seguros.
          </p>
          <div style={{ marginTop: 16, display: "flex", gap: 8, justifyContent: "center" }}>
            <button onClick={() => window.location.reload()} style={{ background: "#023E8A", color: "#fff", fontWeight: 600, border: "none", borderRadius: 10, padding: "10px 18px", cursor: "pointer" }}>Recarregar</button>
            <button onClick={() => window.location.assign("/")} style={{ background: "#FB8500", color: "#fff", fontWeight: 600, border: "none", borderRadius: 10, padding: "10px 18px", cursor: "pointer" }}>Voltar ao início</button>
          </div>
        </div>
      </div>
    );
  }
}
